export default "__VITE_ASSET__DQK0S5lb__"